import fetch from '../../../services/fetch-api.service';

const fetchSiks = ({ filters, page, sortField, sortOrder, limit }) => fetch.get('admin/siks/list', { filters, page, sortField, sortOrder, limit });

export default {
  fetchSiks,
};
